/**
 * Work Order Type Definitions.
 */

export interface LaborEntry {
  id: string;
  work_order_id: string;
  user_id: string | null;
  hours: number;
  hourly_rate: number;
  total_cost: number;
  description: string | null;
  work_date: string;
  created_at: string;
}

export interface PartEntry {
  id: string;
  work_order_id: string;
  part_name: string;
  part_number: string | null;
  quantity: number;
  unit_cost: number;
  total_cost: number;
  description: string | null;
  created_at: string;
}

export interface MaterialEntry {
  id: string;
  work_order_id: string;
  material_name: string;
  quantity: number;
  unit: string;
  unit_cost: number;
  total_cost: number;
  description: string | null;
  created_at: string;
}

export interface WorkOrder {
  id: string;
  organization_id: string;
  wo_number: string;
  asset_id: string;
  assigned_to: string | null;
  service_provider_id: string | null;
  assignment_type: string;
  status: string;
  work_type: string;
  title: string;
  description: string | null;
  priority: string;
  estimated_hours: number | null;
  actual_hours: number;
  started_at: string | null;
  completed_at: string | null;
  due_date: string | null;
  total_labor_cost: number;
  total_parts_cost: number;
  total_materials_cost: number;
  total_cost: number;
  form_template_ids: string[] | null;
  notes: string | null;
  created_by: string | null;
  created_at: string;
  updated_at: string;
  labor_entries: LaborEntry[];
  parts_entries: PartEntry[];
  materials_entries: MaterialEntry[];
}

export interface WorkOrderCreate {
  asset_id: string;
  assigned_to?: string;
  service_provider_id?: string;
  assignment_type?: string;
  work_type?: string;
  title: string;
  description?: string;
  priority?: string;
  estimated_hours?: number;
  due_date?: string;
  notes?: string;
  form_template_ids?: string[];
}

export interface LaborEntryCreate {
  user_id?: string;
  hours: number;
  hourly_rate?: number;
  description?: string;
}

export interface PartEntryCreate {
  part_name: string;
  part_number?: string;
  quantity?: number;
  unit_cost: number;
  description?: string;
}

export interface MaterialEntryCreate {
  material_name: string;
  quantity: number;
  unit?: string;
  unit_cost: number;
  description?: string;
}

export const WO_STATUSES = [
  "Open",
  "In Progress",
  "On Hold",
  "Completed",
  "Cancelled",
] as const;

export const WORK_TYPES = [
  { value: "repair", label: "Repair" },
  { value: "maintenance", label: "Maintenance" },
  { value: "refurbishment", label: "Refurbishment" },
  { value: "inspection", label: "Inspection" },
  { value: "conditioning", label: "Conditioning" },
] as const;

export const PRIORITIES = [
  { value: "low", label: "Low" },
  { value: "medium", label: "Medium" },
  { value: "high", label: "High" },
  { value: "urgent", label: "Urgent" },
] as const;
